<div class="modal-body">
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <img src="assets/images/closeX.svg">
    </button>
    <div class="d-flex flex-column justify-content-center">
        <img *ngIf="item.image" class="modalDietImage" [src]="'assets/images/'+item.image+'.svg'">
        <div class="modalDietTtle">{{item.value}}</div>
        <div class="regularCopy" innerHTML={{swapPronouns(item.more)}}>{{swapPronouns(item.more)}}</div>
    </div>
</div>
